module.exports = __webpack_public_path__ + "static/demo1-2b3d002f5d1b5e9399ef6d0e190a0bd8.png";